var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E8B57",
    d: "M20 37.917a17.917 17.917 0 0 1 0-35.834A17.55 17.55 0 0 1 28.034 4 1.253 1.253 0 0 1 26.9 6.233 15 15 0 0 0 20 4.567 15.416 15.416 0 1 0 35.417 20a3 3 0 0 0 0-.417 1.255 1.255 0 0 1 2.5-.233V20A17.933 17.933 0 0 1 20 37.917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E8B57",
    d: "M19.7 25.683a1.17 1.17 0 0 1-.866-.367l-8.05-7.9a1.25 1.25 0 0 1 0-1.766 1.284 1.284 0 0 1 1.783 0l7.15 7.05L35.8 6.883a1.283 1.283 0 0 1 1.784 0 1.25 1.25 0 0 1 0 1.767L20.617 25.316a1.23 1.23 0 0 1-.917.367"
  })));
};
export default SvgCheckCircle;